import React, { Component } from 'react';
import InputText from '../../commonModules/interface/form-input-inline';
import { Grid, Button, IconButton } from '@material-ui/core';
import { EditRounded } from '@material-ui/icons';

class SuperAdminCode extends Component {
    state = { 
        actual_email: "",
        email_ref: "",
        
        updateForm: false
    }
    componentDidMount() {
        this.getCodeSuperAdmin()
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    getCodeSuperAdmin = async () => {
        let req = await fetch("/code/request/superadmin",{
            method:"GET",
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin',
        })
        let res = await req.json()

        console.log("getRefEmail", {res});
        if(res.error !== "OK"){
            console.log("getRefEmail", res.error.error);
        } else {
            this.setState({
                actual_email: res.content.code
            })    
        }
    }
    
    render() {
        return (
            <div>
                <h3>Code Superadmin</h3>
                <hr/>
                <h4> Code actuel : {this.state.actual_email || ""} 
                    <IconButton onClick={()=>this.setState({updateForm: true})} >
                        <EditRounded />
                    </IconButton>
                    {/* <i className="zmdi zmdi-edit c-blue" onClick={()=>this.setState({updateForm: true})} style={{paddingLeft: "10px", cursor:"pointer", fontSize:"20px" }}></i>  */}
                </h4>
            </div>
        );
    }
}

export default SuperAdminCode;